module.exports = __webpack_public_path__ + "img/lunbo1.d1255c5d.jpg";